__webpack_require__.p = "/wizualizacje/";